<template>
    <div>
        <LoadingOverlay
            id="packs-loading-overlay"
            v-if="this.loading"
        ></LoadingOverlay>
        <div class="py-4">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <h2 class="text-center title-bold">
                            {{ app.locale.trans('course.title.choose') }}
                        </h2>
                        <!-- Separator only visible on large screens -->
                        <hr class="d-none d-md-block w-75 mx-auto" />
                        <h4 class="text-center mt-4 mb-3">{{ pack.name }}</h4>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 col-md-6">
                        <div class="row">
                            <div
                                class="col-lg-6 col-sm-12 my-3"
                                v-for="(course, index) in pack.courses"
                                :key="course.id"
                            >
                                <div
                                    class="p-3 h-100 d-flex flex-column justify-content-between bg-primary text-white rounded"
                                >
                                    <div class="font-weight-bold">
                                        {{ course.name }}
                                    </div>
                                    <div class="course-info-and-dates">
                                        {{
                                            app.locale.trans(
                                                'course.info.duration',
                                                {
                                                    ':duration':
                                                        formatCourseDuration(
                                                            course.duration
                                                        ),
                                                }
                                            )
                                        }}
                                        <br />
                                        <template
                                            v-if="city && !course.is_online"
                                        >
                                            {{ city.name }}
                                        </template>
                                        <template v-else>
                                            {{
                                                app.locale.trans(
                                                    'common.nav.online-course'
                                                )
                                            }}
                                        </template>
                                        <br />
                                        <div class="form-group m-0">
                                            <label
                                                :for="
                                                    'dates-course-' + course.id
                                                "
                                                >{{
                                                    app.locale.trans(
                                                        'user.cart.dates'
                                                    )
                                                }}</label
                                            >
                                            <select
                                                :id="
                                                    'dates-course-' + course.id
                                                "
                                                class="form-control custom-select"
                                                v-model="selectedEvents[index]"
                                            >
                                                <option value="-1">
                                                    {{
                                                        app.locale.trans(
                                                            'course.pack.infos_and_dates'
                                                        )
                                                    }}
                                                </option>
                                                <template
                                                    v-for="event in course.events"
                                                >
                                                    <option
                                                        :value="event"
                                                        :key="event.dateRef"
                                                        v-if="
                                                            !event.is_cancelled &&
                                                            !event.isFull
                                                        "
                                                    >
                                                        {{
                                                            mixins.methods.dateFullText(
                                                                event.start_datetime,
                                                                event.timezone,
                                                                course.is_online
                                                            ) +
                                                            ' de ' +
                                                            mixins.methods.hour(
                                                                event.start_datetime,
                                                                event.timezone,
                                                                course.is_online
                                                            ) +
                                                            ' à ' +
                                                            mixins.methods.hour(
                                                                event.end_datetime,
                                                                event.timezone,
                                                                course.is_online
                                                            ) +
                                                            (course.is_online
                                                                ? ' (' +
                                                                  userTimeZone +
                                                                  ')'
                                                                : '') +
                                                            ' - ' +
                                                            formatPrice(
                                                                course
                                                                    .validTicketTypes[0]
                                                                    .cost,
                                                                course
                                                                    .validTicketTypes[0]
                                                                    .currency
                                                                    .code
                                                            )
                                                        }}
                                                    </option>
                                                </template>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 my-auto">
                        <AlertBox
                            id="packs-alert-box"
                            ref="alertBox"
                        ></AlertBox>
                        <div
                            class="price d-flex align-items-baseline justify-content-center justify-content-md-start"
                        >
                            <span class="title-bold text-success mr-2"
                                >{{
                                    app.locale.trans('user.cart.price')
                                }}:</span
                            >
                            <del class="text-muted old-price mr-1">{{
                                formatPrice(basePrice, currency.code)
                            }}</del>
                            <span class="new-price">{{
                                formatPrice(packDiscountedPrice, currency.code)
                            }}</span>
                        </div>
                        <hr />
                        <p
                            v-html="
                                app.locale.trans('course.pack.instructions', {
                                    ':quantity': pack.courses.length,
                                })
                            "
                        ></p>
                        <div
                            class="d-flex justify-content-lg-between justify-content-center flex-wrap"
                        >
                            <button
                                :title="
                                    app.locale.trans('user.cart.add_to_cart')
                                "
                                class="btn btn-success btn-sm-text-wrap add-to-cart p-3"
                                @click="addPackToCart(true)"
                            >
                                {{
                                    app.locale.trans('user.cart.add_to_cart')
                                }}&nbsp;<i
                                    class="fas fa-shopping-cart ml-2"
                                ></i>
                            </button>
                            <button
                                :title="
                                    app.locale.trans(
                                        'user.cart.add_to_cart_and_choose_later'
                                    )
                                "
                                class="btn btn-sm-text-wrap mt-3 add-to-cart p-3 btn-transparent"
                                @click="addPackToCart(false)"
                            >
                                {{
                                    app.locale.trans(
                                        'user.cart.add_to_cart_and_choose_later'
                                    )
                                }}&nbsp;<i
                                    class="fas fa-shopping-cart ml-2"
                                ></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AlertBox from './../../../vue/AlertBox.vue';
import LoadingOverlay from './../../../vue/LoadingOverlay.vue';
import MixinsVue from './../../../mixins/Vue.js';
import CartApiService from './../../../class/service/CartApiService';

export default {
    props: {
        packJson: String,
        cityJson: String,
    },

    data() {
        let cartApiService = new CartApiService();
        let pack = JSON.parse(this.packJson);
        let city = this.cityJson != '' ? JSON.parse(this.cityJson) : null;

        let basePrice = 0;
        let currency = null;
        let selectedEvents = [];
        let ticketTypesIds = [];
        let selectedCurrency = window.app.getSelectedCurrency();

        pack.courses.forEach((course, index) => {
            selectedEvents[index] = '-1';
            let validTicketTypesId = 0;

            for (let ticketTypeIndex in course.validTicketTypes) {
                if (
                    course.validTicketTypes[ticketTypeIndex].currency_id ===
                    selectedCurrency.id
                ) {
                    validTicketTypesId = ticketTypeIndex;
                }
            }

            ticketTypesIds[index] =
                course.validTicketTypes[validTicketTypesId].id;
            basePrice += course.validTicketTypes[validTicketTypesId].cost;
            currency = course.validTicketTypes[validTicketTypesId].currency;

            course.events.forEach((event) => {
                if (!course.is_online) {
                    event.city_id = city.id;
                } else {
                    event.city_id = null;
                }
            });
        });

        let packDiscountedPrice = basePrice;

        if (pack.is_fixed_amount) {
            packDiscountedPrice -= pack.discount_amount;
        } else if (pack.is_percentage) {
            packDiscountedPrice -= Math.round(
                (pack.percentage / 100) * packDiscountedPrice
            );
        }

        return {
            userTimeZone: this.app.locale.getUserTimezone(),
            mixins: MixinsVue.methods.vue,
            pack: pack,
            city: city,
            loading: false,
            addToCartSuccess: true,
            selectedEvents: selectedEvents,
            ticketTypesIds: ticketTypesIds,
            packDiscountedPrice: packDiscountedPrice,
            basePrice: basePrice,
            currency: currency,
            cart_url: appData.page.vars.cart_url,
            cartApiService: cartApiService,
        };
    },

    components: {
        AlertBox,
        LoadingOverlay,
    },

    methods: {
        formatPrice(price, currencyCode) {
            return window.app.formatPrice(price, currencyCode);
        },
        addPackToCart: function (withDates) {
            if (withDates) {
                let allDatesSet = true;
                // We check that all the dates have been set
                this.selectedEvents.forEach((event) => {
                    // If a date have not been set, we return an error and stop the process
                    if (event == '-1') {
                        allDatesSet = false;
                        this.$refs.alertBox.showAlertMessage(
                            'danger',
                            app.locale.trans('course.pack.choose_all_dates')
                        );
                    }
                });

                if (allDatesSet) {
                    this.sendAddPackToCartRequest(withDates);
                }
            } else {
                this.sendAddPackToCartRequest(withDates);
            }
        },

        sendAddPackToCartRequest: function (withDates) {
            let events = withDates ? this.selectedEvents : null;

            this.cartApiService
                .addCartPack(
                    this.pack.id,
                    this.pack.name,
                    this.basePrice,
                    this.packDiscountedPrice,
                    1,
                    this.currency.id,
                    events,
                    this.ticketTypesIds,
                    appData.page.vars.city_id
                )
                .then((gtmData) => {
                    // Send only current cart item.
                    gtmData.ecommerce.items =
                        appData.page.vars.gtmData.ecommerce.items;
                    gtmData.ecommerce.value =
                        appData.page.vars.gtmData.ecommerce.value;

                    let gtmTicket = {};

                    gtmTicket.cost = this.price;
                    gtmTicket.currency = this.currency;
                    gtmTicket.course_id = [];

                    this.ticketTypesIds.forEach((id) => {
                        gtmTicket.course_id.push(id);
                    });

                    // Trigger GTM event.
                    this.app.gtm.trigger('add_to_cart', {
                        // Get data from response.
                        ...gtmData,
                        ...{
                            ticket: gtmTicket,
                        },
                    });

                    // Redirect.
                    window.location = this.cart_url;
                })
                .catch((error) => {
                    this.$refs.alertBox.handleError(error);
                });
        },

        formatCourseDuration: function (durationArray) {
            let duration = '';

            switch (durationArray['days']) {
                case 0:
                    duration =
                        durationArray['hours'] + 'h' + durationArray['minutes'];
                    break;
                case 1:
                    duration = durationArray['days'] + 'jour';
                    break;
                default:
                    duration = durationArray['days'] + 'jours';
                    break;
            }

            return duration;
        },
    },
};
</script>
